/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

 


$(document).ready(function () {
  
  $('.thumb-desk-slide').slick({
  infinite: false,
  slidesToShow: 2,
  slidesToScroll: 2,
    arrows: false,
});
  
  $('.thumb-desk-slide .media-thumb').on('click', function () { 
    var index = $(this).data('slick-index');  
    $('.js-product-slider').slick('slickGoTo', index);
  });

  // Sync active state for thumbnails (optional, if needed for UI feedback)
  $('.main-slider').on('afterChange', function (event, slick, currentSlide) {
    // Remove active class from all thumbnails
    $('.thumb-desk-slide').removeClass('active');

    // Add active class to the thumbnail matching the current slide
    $(`.thumb-desk-slide[data-slick-index="${currentSlide}"]`).addClass('active');
  });

  

    var buyBlocks = $('.f-buy-block');
    var currentIndex = 0;

    // Function to show the next block
    function showNextBlock() {
      // Hide the current block
      $(buyBlocks[currentIndex]).hide();

      // Get a random index for the next block
      currentIndex = Math.floor(Math.random() * buyBlocks.length);

      // Show the next block
      $(buyBlocks[currentIndex]).show();
    }

    // Show the first block immediately
    showNextBlock();

    // Set an interval to show the next block every 10 minutes (600,000 milliseconds)
    setInterval(showNextBlock, 600000); // 10 minutes


  
$('.slider_collection').slick({
  centerMode: true,
  centerPadding: '25%',
  slidesToShow: 1,
  cssEase: 'ease-in-out',
   infinite: true,
  speed: 500,
  prevArrow: `<button class="slick-prev" aria-label="Previous" type="button">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="94" height="94" viewBox="0 0 94 94">
  <defs>
    <filter id="Ellipse_160" x="0" y="0" width="94" height="94" filterUnits="userSpaceOnUse">
      <feOffset input="SourceAlpha"/>
      <feGaussianBlur stdDeviation="5" result="blur"/>
      <feFlood flood-opacity="0.161"/>
      <feComposite operator="in" in2="blur"/>
      <feComposite in="SourceGraphic"/>
    </filter>
  </defs>
  <g id="Group_344" data-name="Group 344" transform="translate(15 15)">
    <g transform="matrix(1, 0, 0, 1, -15, -15)" filter="url(#Ellipse_160)">
      <circle id="Ellipse_160-2" data-name="Ellipse 160" cx="32" cy="32" r="32" transform="translate(15 15)" fill="#fff"/>
    </g>
    <path id="Icon_ionic-ios-arrow-round-forward" data-name="Icon ionic-ios-arrow-round-forward" d="M17.807,11.6a1.244,1.244,0,0,1,.01,1.752l-5.79,5.8H34.062a1.238,1.238,0,0,1,0,2.476H12.036l5.79,5.8a1.253,1.253,0,0,1-.01,1.752,1.233,1.233,0,0,1-1.743-.01l-7.847-7.9h0a1.39,1.39,0,0,1-.257-.39,1.181,1.181,0,0,1-.1-.476,1.241,1.241,0,0,1,.352-.867l7.847-7.9A1.213,1.213,0,0,1,17.807,11.6Z" transform="translate(10.418 11.606)"/>
  </g>
</svg>

              </button>`,
  nextArrow: `<button class="slick-next" aria-label="Next" type="button">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="94" height="94" viewBox="0 0 94 94">
  <defs>
    <filter id="Ellipse_160" x="0" y="0" width="94" height="94" filterUnits="userSpaceOnUse">
      <feOffset input="SourceAlpha"/>
      <feGaussianBlur stdDeviation="5" result="blur"/>
      <feFlood flood-opacity="0.161"/>
      <feComposite operator="in" in2="blur"/>
      <feComposite in="SourceGraphic"/>
    </filter>
  </defs>
  <g id="Group_343" data-name="Group 343" transform="translate(-1271 -3212)">
    <g transform="matrix(1, 0, 0, 1, 1271, 3212)" filter="url(#Ellipse_160)">
      <circle id="Ellipse_160-2" data-name="Ellipse 160" cx="32" cy="32" r="32" transform="translate(15 15)" fill="#fff"/>
    </g>
    <path id="Icon_ionic-ios-arrow-round-forward" data-name="Icon ionic-ios-arrow-round-forward" d="M25.358,11.6a1.244,1.244,0,0,0-.01,1.752l5.79,5.8H9.1a1.238,1.238,0,0,0,0,2.476H31.129l-5.79,5.8a1.253,1.253,0,0,0,.01,1.752,1.233,1.233,0,0,0,1.743-.01l7.847-7.9h0a1.39,1.39,0,0,0,.257-.39,1.181,1.181,0,0,0,.1-.476,1.241,1.241,0,0,0-.352-.867l-7.847-7.9A1.213,1.213,0,0,0,25.358,11.6Z" transform="translate(1296.417 3238.606)"/>
  </g>
</svg>

              </button>`,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: true, // Ensure arrows are visible on this breakpoint
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        arrows: true, // Ensure arrows are visible on this breakpoint
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 1
      }
    }
  ]
});

  
});

 
window.addEventListener("load", function () {
    AOS.refresh();
});



